/** Scroll to a field or section, focus its first control and flash it. */
export function jumpTo(targetId: string) {
  const el = document.getElementById(targetId)
  if (!el) return
  // Scroll only the nearest scrolling column: scrollIntoView also moves the app frame.
  let pane: HTMLElement | null = el.parentElement
  while (pane && !/(auto|scroll)/.test(getComputedStyle(pane).overflowY)) pane = pane.parentElement
  if (pane) {
    const offset = el.getBoundingClientRect().top - pane.getBoundingClientRect().top
    pane.scrollTo({ top: pane.scrollTop + offset - pane.clientHeight / 3, behavior: 'smooth' })
  }
  const control = el.querySelector<HTMLElement>('input:not([type=hidden]):not([disabled]), textarea:not([disabled]), select:not([disabled]), button:not([disabled])')
  control?.focus({ preventScroll: true })
  el.setAttribute('data-flash', 'true')
  window.setTimeout(() => el.removeAttribute('data-flash'), 1600)
}
